
import Vue from 'vue';
import Component from 'vue-class-component';
import UserCard from '@/components/Shared/UserCard.vue';
import EmailDynamic from '@/components/Shared/EmailDynamic.vue';
import SkillsSelector from '@/components/Shared/SkillsSelector.vue';
import { challengeModule, countriesState, countryModule, teamModule, teamsState } from '@/utils/store-acessor';
import { CountryModel } from '@/models/country.model';
import { UserApi } from '@/api/user.api';
import { take } from 'rxjs/operators';
import { UserModel } from '@/models/user.model';
import { SkillModel } from '@/models/skill.model';
import { ChallengeModel } from '@/models/challenge.model';
import { TeamModel } from '@/models/team.model';

@Component({
  components: {
    UserCard,
    EmailDynamic,
    SkillsSelector
  }
})
export default class TeamInvitation extends Vue {
  @countryModule.Getter('countries') countries!: CountryModel[];
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @teamModule.Getter('selectedTeam') team!: TeamModel;
  skills: number[] = [];
  skillNames: string[] = [];
  selectedCountry: CountryModel | null = null;
  usersToInvite: UserModel[] = [];
  loading = false;
  sendLoading = false;
  snackbarVisibility = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarText = '';
  currentPage = 1;
  lastPage = 1;

  mounted() {
    countriesState.requestAllCountries();
  }

  onEmailsEnter(emails: string[]) {
    console.log(emails);
  }

  isInInvitationRoute(): boolean {
    return this.$route.name === 'invite-user-to-team';
  }

  onSearchUsers() {
    this.loading = false;
    this.fetchUsersPaginated(this.currentPage, false);
  }

  skillSelected(skill: SkillModel) {
    const indexId = this.skills.findIndex(v => v == skill.id);
    const indexName = this.skillNames.findIndex(v => v == skill.abbr);
    if (~indexId && ~indexName) {
      this.skills.splice(indexId, 1);
      this.skillNames.splice(indexName, 1);
    } else if (skill?.id && skill?.abbr) {
      this.skills.push(skill.id);
      this.skillNames.push(skill.abbr);
    }
  }

  fetchUsersPaginated(page: number, upsert: boolean = true) {
    if (this.challenge?.id) {
      this.loading = true;
      new UserApi().searchUsersToInvite({
        challengeId: this.challenge.id,
        skills: this.skillNames,
        residenceId: this.selectedCountry?.id,
        teamId: this.team?.id,
        page
      }).pipe(
        take(1)
      ).subscribe((response) => {
        this.loading = false;
        if (upsert) {
          this.usersToInvite.push(...response.data);
        } else {
          this.usersToInvite = response.data;
        }
        this.currentPage = response.current_page;
        this.lastPage = response.last_page;
      }, () => (this.loading = false)
      );
    }
  }

  async onSendInvitations() {
    if (this.challenge?.id && this.team?.id) {
      try {
        this.sendLoading = true;
        await teamsState.onInviteUsers({
          challengeId: this.challenge.id,
          teamId: this.team.id
        });
        this.sendLoading = false;
        this.snackbarMessage('invites.messages.send.success', 'green');
      } catch (e) {
        this.sendLoading = false;
        this.snackbarMessage('invites.messages.send.failed', 'red');
      }
    }
  }

  private snackbarMessage(message: string, color: 'green' | 'red') {
    this.snackbarColor = color;
    this.snackbarText = message;
    this.snackbarVisibility = true;
  }
}
